import { BaseRecordSchema, defineValidation } from "../../common/validation.common";

export namespace AgentInvoiceValidation {
    export const Record = defineValidation(BaseRecordSchema);
}
